// Copyright (c) 2017 Deere & Company

import AuditPreparation from '@deere/cps-it.warranty-model-factory/lib/audit-preparation';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const matchClaimType = (claim, claimToRemove) =>
    claim.claimNumber === claimToRemove.claimNumber && claim.claimType.key === claimToRemove.claimType.key;

const updateAuditPreparationClaims = (state, action) => {

    const index = state.claims.findIndex(claim => claim.claimType.key === 'ZZMK' ?
        matchClaimType(claim, action.itemToRemove) && claim.subClaimType.key === action.itemToRemove.subClaimType.key :
        matchClaimType(claim, action.itemToRemove));

    return AuditPreparation.update(state, {
        claims: {
            $splice: [
                [
                    index,
                    1
                ]
            ]
        }
    });

};

const replaceAuditPreparationClaims = (state, action) =>
    AuditPreparation.update(state, {
        claims: {
            $set: action.claims
        }
    });

const addClaim = (state, action) =>
    AuditPreparation.update(state, {
        claims: {
            $push: [action.itemToAdd]
        }
    });

const updateAuditPreparation = (state, action) =>
    AuditPreparation.update(state, {
        $merge: action.data
    });

const updateUserSelectedClaimsMinimum = (state, action) =>
    AuditPreparation.update(state, {
        userSelectedClaimsMinimum: {
            $set: action.userSelectedClaimsMinimum
        }
    });

export default (state = getDefaultState().auditPreparation, action) => {

    const actionTypes = {
        [actions.ADD_CLAIM_TO_TCSM_AUDIT]: addClaim,
        [actions.REMOVE_CLAIM_FROM_TCSM_AUDIT]: updateAuditPreparationClaims,
        [actions.REPLACE_TCSM_PREPARE_AUDIT_CLAIMS]: replaceAuditPreparationClaims,
        [actions.RESET_TCSM_PREPARE_AUDIT_AUDIT]: updateAuditPreparation,
        [actions.UPDATE_TCSM_PREPARE_AUDIT_AUDIT]: updateAuditPreparation,
        [actions.UPDATE_TCSM_PREPARE_AUDIT_USER_SELECTED_CLAIMS_MINIMUM]: updateUserSelectedClaimsMinimum
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/reducers/audit-preparation.js